import { MDXRemoteSerializeResult } from "next-mdx-remote";

export class StrapiQuestionDTO {
  constructor() {}

  documentId: string;
  question: string;
  answer: string;
  displayOrderIndex: number;
  category: "General" | "Treatment" | "Booking" | "Insurance" | "Practical";
  featuredOnHomepage: boolean;
}

export class QuestionDTO {
  constructor() {}

  extraData: any = {};
  documentId: string;
  question: string;
  answer: MDXRemoteSerializeResult;
  /** plain-text answer for FAQPage JSON-LD — schema.org text, not MDX */
  answerText: string;
  displayOrderIndex: number;
  category: "General" | "Treatment" | "Booking" | "Insurance" | "Practical";
  featuredOnHomepage: boolean;
}
